export const PAYOUT_PAGE_SIZE = 50;

// A drawer renders its overlay at `layer` and its panel at `layer + 1`. The nested
// transaction drawer sits above the payment drawer (base layer 1000), and the toast
// has to clear the nested panel, so it is derived from it instead of being a bare number.
export const NESTED_DRAWER_LAYER = 1100;
export const BOTTOM_TOAST_Z_INDEX = NESTED_DRAWER_LAYER + 10;

export const PAYOUTS_TABS = {
  PAYMENTS: "PAYMENTS",
  TRANSACTIONS: "TRANSACTIONS",
};

export const PAYOUT_PAGE_TABS = [
  { key: PAYOUTS_TABS.PAYMENTS, label: "Payments" },
  { key: PAYOUTS_TABS.TRANSACTIONS, label: "Transactions" },
];

export const PAYMENT_STATUS_FILTERS = [
  { key: "upcoming", label: "Upcoming" },
  { key: "paid", label: "Paid" },
];

export const TRANSACTION_STATUS_FILTERS = [
  { key: "invoices", label: "Invoices" },
  { key: "return_notes", label: "Return notes" },
  { key: "debit_note", label: "Debit note" },
  { key: "other", label: "Other" },
];

export const PAYMENT_STATUS_CODES = {
  upcoming: ["PENDING", "QUEUED_FOR_PAYOUT", "FAILED"],
  paid: ["PAID"],
};

export const TRANSACTION_TYPE_CODES = {
  invoices: "GRN_COMPLETE",
  return_notes: "PRN",
  debit_note: "DN",
};

export const OTHER_EXCLUDABLE_TYPES = ["GRN_COMPLETE", "PRN", "DN"];

export const FROM_ENTITY = { id: "HYPERPURE", type: "BUSINESS" };
export const TO_ENTITY_TYPE = "VENDOR";
